<shr-person [form]="form" [person]="user" [addressRequired]="false">
</shr-person>

<div class='d-flex py-1'>
    <label class="col-4 form-control-label" for="governing-parish-select" id="governing-parish-label">Governing Parish :</label>
    <div class="col-8">
        <shr-parish [(parish)]="user.governingParish" [readonly]="false" [form]="form" [controlId]="'governing-parish-select'" [labelledBy]="'governing-parish-label'"></shr-parish>
    </div>
</div>
